import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { animated } from '@react-spring/web'
import imageCloudLeft from '../../assets/images/clouds/cloud-left.png';
import imageCloudLeftMobile from '../../assets/images/clouds/cloud-left-mobile.png';
import imageCloudRight from '../../assets/images/clouds/cloud-right.png';
import imageCloudRightMobile from '../../assets/images/clouds/cloud-right-mobile.png';
import './CloudHuge.scss';
import { useMediaQuery } from '../../utils';

const images = {
	left: imageCloudLeft,
	right: imageCloudRight,
	leftMobile: imageCloudLeftMobile,
	rightMobile: imageCloudRightMobile
};

export const CloudHuge = memo(props => {
	const { className, style, type } = props;
	const isMobile = useMediaQuery('(max-aspect-ratio: 9/13)');
	let src = images[type + (isMobile ? 'Mobile' : '')];
	const classNameTyped = type === 'left' ? 'cloud-huge-left' : 'cloud-huge-right';
	const classNameInner = 'cloud-huge ' + classNameTyped;

	return (
		<animated.div style={style} className={className}>
			<img className={classNameInner} src={src} alt="huge cloud" />
		</animated.div>
	);
});

CloudHuge.propsTypes = {
	className: PropTypes.string,
	style: PropTypes.object,
	type: PropTypes.oneOf(['left', 'right']),
};
